import ApiService from "@/common/api/api.service";

//let endpoint = "ProjetoGestao";

const XML = {
    
    /*setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },*/

    salvar(xml, form) {
        return ApiService.post(`ProjetoGestao/${xml}`, form)
    },

    listar(xml,projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`ProjetoGestao/${xml}?ProjetoGestaoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscar(xml, id) {
        return ApiService.get(`ProjetoGestao/${xml}?id=${id}`);
    },

    deletar(xml, id) {
        let form = {
            id: id
        }
        return ApiService.delete(`ProjetoGestao/${xml}`, form);
    },

    download(xml, id) {
        return ApiService.downloadFile(`ProjetoGestao/${xml}`,`download-arquivo?id=${id}`);
    },
}

export default XML;
